import { isPwa } from '@ghl/clientportal-core/init'
import postscribe from 'postscribe'

export function sanitizeJavaScriptCode(jsCode: string): string {
  // Remove HTML tags and leading/trailing white spaces
  return jsCode.replace(/<\/?[^>]+(>|$)/g, '').trim()
}
export const initiateCustomTags = (data: any): void => {
  if (isPwa()) {
    return
  }
  addCustomCSSTag(data)
  addCustomJsTag(data)
  if (data?.headerCode) {
    // Configure postscribe to not use fetch for scripts
    postscribe(`#clientportal-siteCustomHeader`, data.headerCode, {
      beforeWriteToken: token => {
        // Prevent postscribe from fetching external scripts
        if (token.tagName === 'script' && token.attrs.src) {
          return false // Let browser handle script loading naturally
        }
        return token
      },
    })
  }
  if (data?.footerCode) {
    postscribe(`#clientportal-siteCustomFooter`, data.footerCode, {
      beforeWriteToken: token => {
        // Prevent postscribe from fetching external scripts
        if (token.tagName === 'script' && token.attrs.src) {
          return false // Let browser handle script loading naturally
        }
        return token
      },
    })
  }
}
export const addCustomCSSTag = (data: any): void => {
  const customCssCode = document.createElement('style')
  customCssCode.setAttribute('type', 'text/css')
  customCssCode.setAttribute('vmid', 'clientportal-site-custom-css')
  ;(customCssCode.innerHTML = data.customCss),
    document.head.appendChild(customCssCode)
}
export const addCustomJsTag = (data: any): void => {
  const customScript = document.createElement('script')
  customScript.setAttribute('type', 'text/javascript')
  customScript.setAttribute('vmid', 'clientportal-site-custom-js')
  customScript.innerHTML = sanitizeJavaScriptCode(data?.customJs || '')
  document.head.appendChild(customScript)
}
export const initiateCustomTagsCommunities = async (
  data: any
): Promise<boolean> => {
  if (isPwa()) {
    return false
  }

  if (data?.customCode === 'false') {
    return false
  }

  if (data?.liveMode === true || data?.customCode === 'true') {
    addCustomCSSTagCommunities(data)
    addCustomJsTagCommunities(data)
    if (data?.headerCode) {
      postscribe(`#communities-siteCustomHeader`, data.headerCode)
    }
    if (data?.footerCode) {
      postscribe(`#communities-siteCustomFooter`, data.footerCode)
    }
    return true
  }
  return false
}
export const addCustomCSSTagCommunities = (data: any): void => {
  const customCssCode = document.createElement('style')
  customCssCode.setAttribute('type', 'text/css')
  customCssCode.setAttribute('vmid', 'communities-site-custom-css')
  ;(customCssCode.innerHTML = data?.customCss),
    document.head.appendChild(customCssCode)
}
export const addCustomJsTagCommunities = (data: any): void => {
  const customScript = document.createElement('script')
  customScript.setAttribute('type', 'text/javascript')
  customScript.setAttribute('vmid', 'communities-site-custom-js')
  customScript.innerHTML = sanitizeJavaScriptCode(data?.customJs || '')
  document.head.appendChild(customScript)
}
